module.exports = __webpack_public_path__ + "media/images/icon__predict-bb82e6566dd887b604447519b3729e5c.png";